import type { RecipeStep, StepKind } from "./recipes";

const KIND_ORDER: Record<StepKind, number> = {
  prep: 0,
  cook: 1
};

export function sortStepsForCookMode(steps: readonly RecipeStep[]): RecipeStep[] {
  return [...steps].sort((left, right) => {
    const leftKind = left.kind ?? "cook";
    const rightKind = right.kind ?? "cook";
    const kindDelta = KIND_ORDER[leftKind] - KIND_ORDER[rightKind];
    if (kindDelta !== 0) {
      return kindDelta;
    }
    return 0;
  });
}
